<script lang="ts">
    import { fade } from 'svelte/transition';
    import OpenButton from "$lib/components/ui/OpenButton.svelte";
    import {Button} from "flowbite-svelte";
    import {ChevronDownOutline, ChevronUpOutline} from "flowbite-svelte-icons";
    export let headline:string;
    export let collapsible:boolean = false
    export let open:boolean = !!collapsible;
</script>

<div class="rounded-lg bg-white shadow ring-1 ring-black ring-opacity-5  divide-y divide-gray-300">
    <div class="flex w-full justify-between p-3 bg-gray-50">
        <div class="flex gap-3">
            <div class="font-semibold text-gray-900 leading-6">
                {headline}
            </div>

            {#if $$slots["cta"]}
                <div>
                    <slot name="cta" />
                </div>

            {/if}
        </div>

        {#if collapsible}
            <Button class="!p-2" pill outline on:click={() => open = !open}>
                {#if open}
                    <ChevronUpOutline  class="w-4 h-4"/>
                {:else}
                    <ChevronDownOutline class="w-4 h-4" />
                {/if}
            </Button>
        {/if}
    </div>
    <slot name="header"/>
    {#if open || !collapsible}
    <div transition:fade|global={{duration: 200}} class="flex flex-col lg:flex-row divide-gray-100 gap-6 px-6 py-4">
        <div class="flex flex-col gap-3 w-full">
            <slot name="left"></slot>
        </div>
        {#if $$slots["right"]}
            <div class="bg-gray-200 w-[2px]"></div>
            <div class="flex flex-col gap-3 w-full">
                <slot name="right"></slot>
            </div>
        {/if}
    </div>
    {/if}
</div>
